import { computed, inject, Injectable, signal } from "@angular/core";
import { Venue, VenueZip } from '@interfaces';
import { AppService, FuncService } from "../../../../services";
@Injectable({ providedIn: 'root' })
export class VenueDialogDataService {

	private func = inject(FuncService);
	private app = inject(AppService);
	public venues = signal<Venue[]>([]);
	public zips = signal<VenueZip[]>([]);
	public canEdit = computed(() => this.app.data().permissions.canFacilitateCohorts);


	public async loadAllVenueData() {
		const data = await this.func.venue.getDialogData();
		this.venues.set(data.venues);
		this.zips.set(data.zips);
	}

	public async addVenue(address: { officialName: string, website?: string, streetAddress: string, placeAddress: string, zipId: number, googlePlaceKey: string, latitude: number, longitude: number }) {
		const venueId = await this.func.venue.add({ address });
		await this.loadAllVenueData();
		return venueId;
	}

	public async updateVenue(venue: { venueId: number, displayedName: string, publicNotes: string | undefined, internalNotes: string | undefined }) {
		await this.func.venue.update(venue);
		await this.loadAllVenueData();
	}

	public async deleteVenue(venueId: number) {
		return await this.func.venue.delete({ venueId });
	}


}